import thunk from 'redux-thunk'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { hashHistory } from 'react-router'
import { AdministrationReducer, store as AdministrationReducerStore } from '../administration/reducers/AdministrationReducer'
import { WaitReducer } from 'react-aquasys'
import logger from 'redux-logger'
import { SitesReducer, store as SitesReducerStore } from '../sites/reducers/SitesReducer'
import { HomeReducer, store as HomeReducerStore } from '../home/reducers/HomeReducer'
import SignUpValidationReducer from '../signup/reducers/SignUpValidationReducer'
import LoginReducer from '../login/reducers/LoginReducer'
import { DetailStationReducer, store as DetailStationReducerStore } from '../station/reducers/DetailStationReducer'
import { ReferentialReducer, store as ReferentialReducerStore } from '../referential/reducers/ReferentialReducer'
import { DashboardReducer, store as DashboardReducerStore } from '../dashboard/reducers/DashboardReducer'
import { SelectionReducer, store as SelectionReducerStore } from '../dashboard/reducers/SelectionReducer'
import { CreditReducer, store as CreditReducerStore } from '../home/reducers/CreditReducer'
import { PointReducer, store as PointReducerStore } from '../point/reducers/PointReducer'
import { InitPasswordReducer, store as InitPasswordReducerStore } from '../initPassword/reducers/InitPasswordReducer'
import { store as ToastrReducerStore, ToastrReducer } from '../home/reducers/ToastrReducer'
import { InformationReducer, store as InformationReducerStore } from '../home/reducers/InformationReducer'

const router = routerMiddleware(hashHistory)

const middlewares = [thunk, router]

if (process.env.NODE_ENV !== `production`) {
	middlewares.push(logger)
}
const enhancer = applyMiddleware(...middlewares)

const AppStore = createStore(combineReducers({
	HomeReducer,
	DashboardReducer,
	SelectionReducer,
	SignUpValidationReducer,
	LoginReducer,
	AdministrationReducer,
	DetailStationReducer,
	ToastrReducer,
	InformationReducer,
	WaitReducer,
	SitesReducer,
	ReferentialReducer,
	CreditReducer,
	PointReducer,
	InitPasswordReducer,
	routing: routerReducer
}), {
	ReferentialReducer: ReferentialReducerStore,
	LoginReducer: {
		error: '',
		success: ''
	},
	AdministrationReducer: AdministrationReducerStore,
	SignUpValidationReducer: {
		error: '',
		success: ''
	},
	DashboardReducer: DashboardReducerStore,
	SelectionReducer: SelectionReducerStore,
	HomeReducer: HomeReducerStore,
	DetailStationReducer: DetailStationReducerStore,
	SitesReducer: SitesReducerStore,
	CreditReducer: CreditReducerStore,
	PointReducer: PointReducerStore,
	InitPasswordReducer: InitPasswordReducerStore,
	ToastrReducer: ToastrReducerStore,
	InformationReducer: InformationReducerStore,
	WaitReducer: {
		isWait: false,
		name: 'ball-grid-pulse',
		color: 'blue',
		fadeIn: 'none'
	}
}, enhancer)

export default AppStore



// WEBPACK FOOTER //
// ./src/store/AppStore.js